/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const AuditingApiEnum = {
    GET_ALL: (orgId: string): string => {
        return `/organisations/${orgId}/audit`;
    }
};

